import { useTranslation } from 'react-i18next'

import Dashboard from '@/components/Dashboard'
import GroupsSettings from '@/components/Groups/GroupsSettings/GroupsSettings'

import GroupSettingHeader from './group-settings-header'

export const GroupsSettingsPage = () => {
  const { t } = useTranslation(['groups'])
  return (
    <Dashboard.Container className={`ctp-groups`}>
      <GroupSettingHeader title={t('groups:settings.title')} />
      <div className="ctp-groups__inner">
        <GroupsSettings />
      </div>
    </Dashboard.Container>
  )
}
